import { groupBy } from 'lodash-es';
import { DateTime, Interval } from 'luxon';
import { PositionsSlotId, PositionsSlotsUsersInfo, UsersInfoId } from '../generated/types';
import { Emptyable } from '../util/emptyable';

export interface PositionsSlotsIdsByUserInfoId {
    userInfoId: UsersInfoId;
    positionsSlotsIds: PositionsSlotId[];
}

export function groupPsuis(psuis: PositionsSlotsUsersInfo[]): PositionsSlotsIdsByUserInfoId[] {
    return Object.values(groupBy(psuis, (psui) => psui.userInfoId)).map((psuis) => ({
        userInfoId: psuis[0].userInfoId,
        positionsSlotsIds: psuis.map((psui) => psui.positionSlotId)
    }));
}

type FilterPsui<T> = T & {
    positionSlot: { range: Interval };
};

export function filterStartEndDates<T>(
    psuis: Array<FilterPsui<T>>,
    startDate: Emptyable<DateTime>,
    endDate: Emptyable<DateTime>
): Array<FilterPsui<T>> {
    return psuis.filter((psui) => {
        if (startDate?.isValid && endDate?.isValid) {
            const interval = Interval.fromDateTimes(startDate.startOf('day'), endDate.endOf('day'));

            return psui.positionSlot.range.overlaps(interval);
        } else if (startDate?.isValid) {
            return psui.positionSlot.range.start!.startOf('day').equals(startDate.startOf('day'));
        } else {
            return true;
        }
    });
}
